module.exports = __webpack_public_path__ + "bradavice_3_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/bradavice_3_before.jpg
// module id = 934
// module chunks = 0